import React from 'react'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import ReactDOM from 'react-dom'
import './index.scss'
import AppRoot from 'components/AppRoot/AppRoot'
import config from './config'
import { datadogLogs } from '@datadog/browser-logs'

// Mui's ThemeProvider is unnecessarily cranky about Sentry annotating it and throws an error in the console.
// This error causes false positives in tests, at a min, and could trigger other false positives if we ever monitor
// console errors.
// This workaround suppresses that error log while passing others through to the original console.
const consoleErr = console.error
console.error = (...data: any[]) => {
  if (
    !data.some(
      (en) =>
        en === 'The following props are not supported: `data-sentry-element`, `data-sentry-component`, `data-sentry-source-file`. Please remove them.'
    )
  ) {
    consoleErr(...data)
  }
}

// Sentry.init({
//   dsn: 'https://1e4f10f3d9174107a477683dbe1b0740@sentry.io/1523390',
//   debug: config.debugSentry,
//   environment: config.environment,
//   // This is the Git tag / build number, set in GHA workflows.
//   release: config.build,
//   integrations: [Sentry.extraErrorDataIntegration()],
//   beforeSend(event) {
//     // denyURLs can fail in weird ways, this is a more generic test
//     if (event.request?.url?.includes('localhost')) {
//       console.debug('Sentry event blocked from sending:', event)
//       return null
//     }
//     return event
//   },
// })

datadogLogs.init({
  service: 'command-center',
  clientToken: config.datadogClientToken,
  site: 'datadoghq.com',
  forwardErrorsToLogs: false,
  version: config.build,
  env: config.environment,
  sessionSampleRate: 100,
})

switch (true) {
  case window && window.top && window.top.location && window.top.location !== window.self.location:
    console.warn('this app is not intended to be used within an iframe')
    break
  default:
    let root = <AppRoot />
    if (config.strictMode) {
      console.warn('app is running in strict mode')
      root = (
        <React.StrictMode>
          <AppRoot />
        </React.StrictMode>
      )
    }
    ReactDOM.render(root, document.getElementById('root'))
}
